import type {WorkV4} from 'services/metadata/types';
import {CodeListRef} from 'schemas/references';

export const isWorkValue = (value: unknown): value is WorkV4 =>
  typeof value === 'object' &&
  ((value as WorkV4)?.type === CodeListRef.WORK_TYPE.Bok ||
    (value as WorkV4)?.type === CodeListRef.WORK_TYPE.Vare);
